import React from "react";
import {cva, type VariantProps} from "class-variance-authority";
import {cn} from "../lib/Utils";

// may be nice for some headers className="tracking-tighter"
const textVariants = cva("transition-colors", {
    variants: {
        variant: {
            h1: "font-heading font-bold font-display text-4xl lg:text-5xl tracking-tight sm:text-5xl text-surface-800",
            h2: "font-bold text-3xl text-surface-800 py-4",
            h3: "font-semibold font-primary text-xl text-surface-900",
            h4: "font-semibold text-surface-800 border-b pb-2 border-surface-200",
            p: "text-sm text-surface-700 mt-1",
            label: "block text-sm font-medium text-surface-800 mb-2",
            labelError: "block text-sm font-medium text-surface-500 mb-2 text-red-500",
            blockquote: "mt-6 border-l-2 pl-6 italic",
            small: "text-sm font-medium leading-none",
            muted: "text-sm text-muted-foreground",
        },
    },
    defaultVariants: {
        variant: "p",
    },
});

export interface TypographyProps
    extends React.HTMLAttributes<HTMLElement>,
        VariantProps<typeof textVariants> {
    as?: "h1" | "h2" | "h3" | "h4" | "p" | "label" | "div" | "span" | "blockquote";
}

// USAGE EXAMPLE: <Typography as="h2" variant="h2">Hoofd</Typography>
export const Typography = React.forwardRef<HTMLElement, TypographyProps>(
    ({className, variant, as, ...props}, ref) => {
        const Comp = as || "p";
        return (
            <Comp
                className={cn(textVariants({variant, className}))}
                ref={ref as any}
                {...props}
            />
        );
    }
);

Typography.displayName = "Typography";



